'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = createParamsSerializer;

var _querystring = require('querystring');

var _querystring2 = _interopRequireDefault(_querystring);

var _util = require('./util');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function createParamsSerializer(_ref) {
  var AuthorizationKey = _ref.AuthorizationKey,
      tokenKey = _ref.tokenKey,
      transformRequest = _ref.transformRequest,
      setBodyAuth = _ref.setBodyAuth,
      getCookieFn = _ref.getCookieFn;

  if (!Array.isArray(transformRequest)) {
    transformRequest = [transformRequest];
  }

  transformRequest = transformRequest.filter(function (_) {
    return typeof _ === 'function';
  });

  return function (params) {
    // 伪造get请求的transformRequest处理
    params = (0, _util.mco)(transformRequest, _extends({}, params));

    return _querystring2.default.stringify(_extends({}, setBodyAuth ? _defineProperty({}, AuthorizationKey, getCookieFn(tokenKey)) : {}, params));
  };
}